import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Education"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 1.5V3H6.75V8.25C6.75 11.1495 9.1005 13.5 12 13.5C14.8995 13.5 17.25 11.1495 17.25 8.25V3H21V1.5H3ZM8.25 3H15.75V5.25H8.25V3ZM8.25 8.25C8.25 10.3211 9.92893 12 12 12C14.0711 12 15.75 10.3211 15.75 8.25V6.75H8.25V8.25ZM19.5 22.5H18V20.25C17.9975 18.18 16.32 16.5025 14.25 16.5H9.75C7.67996 16.5025 6.00248 18.18 6 20.25V22.5H4.5V20.25C4.50331 17.3519 6.85188 15.0033 9.75 15H14.25C17.1481 15.0033 19.4967 17.3519 19.5 20.25V22.5ZM3 5.25C3 4.83579 3.33579 4.5 3.75 4.5C4.16421 4.5 4.5 4.83579 4.5 5.25V12H3V5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Education.vue"]]);
